import React from 'react';
import { AlertDialogProvider } from '../../../modal/components/alert-dialog/AlertDialogProvider';
import { ConfirmDialogProvider } from '../../../modal/components/confirm-dialog-v1/ConfirmDialogV1Provider';
import { ConfirmDialogV2Provider } from '../../../modal/components/confirm-dialog-v2/ConfirmDialogV2Provider';
import { ConfirmModalProvider as ToolkitConfirmModalProvider } from '@hevoio/hevo-ui-toolkit';

// Re-usable dialogs go here;
export function GlobalDialogProvidersWrapper({ children }) {
  return (
    <ToolkitConfirmModalProvider>
      <ConfirmDialogProvider>
        <ConfirmDialogV2Provider>
          <AlertDialogProvider>{children}</AlertDialogProvider>
        </ConfirmDialogV2Provider>
      </ConfirmDialogProvider>
    </ToolkitConfirmModalProvider>
  );
}
